import moment from "moment"

const SET_ENTRIES = (state, payload) => {
    if (payload != null && payload != undefined && payload.length > 0) {
        var altered_payload = payload.map(function (value, idx) {
            var entries = value.entries.map(function (val, idx) {
                var datetime = moment(val, "YYYY-MM-DD HH:mm:ss")
                const roundedMinutes = Math.floor(datetime.minutes() / 3) * 3;
                datetime = datetime.minutes(roundedMinutes).seconds(0);
                return datetime.format("YYYY-MM-DD HH:mm")
            })
            value.entries = entries
            if (value.linkQrCode == null) { value.linkQrCode = '' }
            if (value.agents == null) { value.agents = [] }

            if (value.checkin == null) {
                value.checkin = {
                    list: [
                        {   operator: "Trafx",
                            date: Date(value.sdate * 1000).toISOString().split("T")[0]
                        },
                    ],
                    hasCheckin: false,
                    searchText:  "Trafx",
                    dateTime: (value.sdate * 1000)
                }
            }

            if (value.allcats == null || value.allcats == undefined) {
                value.allcats = [
                    [
                        {
                            term_id: 17,
                            name: "Bahia - Chapada Diamantina",
                            slug: "bahia-chapada-diamantina",
                            term_group: 0,
                            term_taxonomy_id: 17,
                            taxonomy: "product_cat",
                            description: "Chapada Diamantina, Bahia",
                            parent: 0,
                            count: 56,
                            filter: "raw"
                        }
                    ],
                    [
                        {
                            term_id: 59,
                            name: "Mucugê",
                            slug: "mucuge",
                            term_group: 0,
                            term_taxonomy_id: 59,
                            taxonomy: "product_cat",
                            description: "",
                            parent: 17,
                            count: 12,
                            filter: "raw"
                        }
                    ],
                    // [
                    //     {
                    //         term_id: 54,
                    //         name: "Vale do Capão",
                    //         slug: "vale-do-capao",
                    //         term_group: 0,
                    //         term_taxonomy_id: 54,
                    //         taxonomy: "product_cat",
                    //         description: "Caeté-Açú",
                    //         parent: 59,
                    //         count: 10,
                    //         filter: "raw"
                    //     }
                    // ]
                ]

            }
            return value
        })
        state.entries = altered_payload
    }
    else {
        state.entries = []
    }
}
const RESET_ENTRIES = (state) => { state.entries = [] }

const SET_FILES = (state, payload) => { state.files = payload || [] }
const RESET_FILES = (state) => { state.files = [] }

const SET_CURRENT_TRAFX_DATA = (state, payload) => { state.current_trafx_data = payload }
const RESET_CURRENT_TRAFX_DATA = (state) => { state.current_trafx_data = {} }

const SET_IS_LOADING = (state, payload) => { state.isLoading = payload }

export default {
    SET_ENTRIES,
    RESET_ENTRIES,

    SET_FILES,
    RESET_FILES,

    SET_CURRENT_TRAFX_DATA,
    RESET_CURRENT_TRAFX_DATA,

    SET_IS_LOADING,
}